import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { api, type User } from "./api";
import Login from "./pages/Login";
import Editions from "./pages/Editions";
import Editor from "./pages/Editor";
import Shell from "./Shell";

export default function App() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    api
      .me()
      .then((r) => setUser(r.user))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, [location.pathname]);

  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center text-neutral-500">
        Loading…
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={user ? <Navigate to="/" replace /> : <Login onLoggedIn={setUser} />}
      />
      <Route
        path="/*"
        element={
          user ? (
            <Routes>
              <Route
                path="/editions/:id"
                element={<Editor />}
              />
              <Route
                path="/*"
                element={
                  <Shell user={user} onLogout={() => setUser(null)}>
                    <Routes>
                      <Route path="/" element={<Editions />} />
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </Shell>
                }
              />
            </Routes>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
}
